import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";

class LongDiscriptionModal extends Component {
    render() {
     
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Long Description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
            <div
            style={{
                width: '100%',
                height: '400px', 
                overflow: 'auto',
            }}
            dangerouslySetInnerHTML={{ __html: this.props.stateData.selectedDiscription }}
        />
        </Modal.Body>
            </Modal>
        )
    }


  
}
export default LongDiscriptionModal;